import * as React from "react";
import Image from "antd/es/image";
import { ExchangeToken } from "./types";
import { optionsProps } from "./constants";

export interface TransferLogoProps {
    token: ExchangeToken;
}

export const TransferLogo: React.FunctionComponent<TransferLogoProps> = (props) => {
    switch (props.token) {
        case "LLD":
            return (
                <div className="Exchange__image-input">
                    <Image src={require("../logo-small.png")} {...optionsProps} />
                </div>
            );
        case "USDT":
            return (
                <div className="Exchange__image-input">
                    <Image src={require("../usdt.svg").default} {...optionsProps} />
                </div>
            );
    }
};